import React from 'react';

const DEFAULT_KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', 'effacer', '0', 'vider'];

function NumericKeypad({
  value = '',
  onChange,
  maxLength = 12,
  className = '',
  compact = false,
}) {
  const safeValue = String(value || '').replace(/\D/g, '');

  const applyNext = (next) => {
    if (typeof onChange === 'function') {
      onChange(String(next || '').replace(/\D/g, ''));
    }
  };

  const handlePress = (key) => {
    if (key === 'effacer') {
      applyNext(safeValue.slice(0, -1));
      return;
    }
    if (key === 'vider') {
      applyNext('');
      return;
    }
    if (safeValue.length >= maxLength) {
      return;
    }
    applyNext(`${safeValue}${key}`);
  };

  return (
    <div className={`loyalty-keypad numeric-keypad ${compact ? 'numeric-keypad-compact' : ''} ${className}`.trim()}>
      {DEFAULT_KEYS.map((key) => (
        <button
          key={key}
          type="button"
          className={`loyalty-key ${key === 'vider' ? 'is-muted' : ''}`}
          onClick={() => handlePress(key)}
        >
          {key === 'effacer' ? '⌫' : key === 'vider' ? 'Vider' : key}
        </button>
      ))}
    </div>
  );
}

export default NumericKeypad;
